import React, { ReactNode } from "react";
import "./text.css";
import { TextSkeleton } from "./text.skeleton";

interface Props {
  children?: ReactNode;
  className?: string;
  align?: "left" | "center" | "right";
  fontStyle?: "italic" | "normal";
  size?: number;
  loading?: boolean;
}

/**
 * Text component
 */
export const Text: React.FC<Props> = ({
  align = "center",
  fontStyle = "normal",
  children,
  size = 16,
  className,
  loading,
}) => {
  return (
    <>
      {loading ? (
        <TextSkeleton />
      ) : (
        <p
          className={`Text ${className || ""}`}
          style={{
            fontSize: `${size}px`,
            textAlign: align,
            fontStyle: fontStyle,
          }}
        >
          {children}
        </p>
      )}
    </>
  );
};
